export function getAdjacentMonth(date: Date, direction: boolean) {
    const newDate = new Date(date);
    if (!direction) {
        newDate.setMonth(newDate.getMonth() - 1);
    } else {
        newDate.setMonth(newDate.getMonth() + 1);
    }
    return newDate;
}

export function formatDate(date: Date): string {
    return date.toISOString().split('T')[0];
}

export function formattedDate(date: Date): string {
    const [year, month, day] = date.toISOString().split('T')[0].split('-');
    return `${month}/${day}/${year}`;
}

export function getYears(year: number, next = true): number[] {
    const years: number[] = [];

    for (let i = 0; i < 12; i++) {
        years.push(next ? year + i : year - i);
    }

    return next ? years : years.reverse();
}
